<div class="content-full-size">
	<div class="content-with-stepper-and-title" *ngIf="productSelected.name === consultation_request">
		<main>
			<div class="header-title">
				<span>{{productsDetail.tittle}}</span>
			</div>
			<div class="description-know-more" *ngFor="let description of productsDetail.descriptions">
				<span>
					{{description}}
				</span>
			</div>
		</main>
	</div>
	<div class="product-detail-component" *ngIf="productSelected.name !== consultation_request">
		<vcl-modal [id]="'vtuModal'" *ngIf="vtu" [modalTitle]="vtu.title" [(showModal)]="showModal"
			(modalButtonClick)='closeModalVTU()' class="modal-display"
			[buttonLabels]=" { primary: copyService.copies.product_selection_modal_close } ">
			<div class="modal">
				<div class="modal-content">
					<span class="introduction" id="vtuIntroduction" [innerHTML]="vtu.introduction"></span>
					<div class="assumptions">
						<div *ngFor="let assumption of vtu.assumptions">
							<span id="vtuTitle{{helper.parseCamelCaseForIds(assumption.title, true)}}"
								class="title">{{assumption.title}}</span>
							<br>
							<span id="vtuDescription{{helper.parseCamelCaseForIds(assumption.title, true)}}"
								class="description">{{assumption.description}}</span>
						</div>
					</div>
					<span id="vtuIndermediate" class="introduction" [innerHTML]="vtu.intermediate"></span>
					<div class="assumptions">
						<span id="vtuTitle{{helper.parseCamelCaseForIds(vtu.principalYield.title, true)}}"
							class="title">{{vtu.principalYield.title}}</span>
						<br>
						<br>
						<span id="vtuDescription{{helper.parseCamelCaseForIds(vtu.principalYield.title, true)}}"
							class="description">{{vtu.principalYield.description}}</span>
						<br>
						<br>
						<div *ngFor="let yield of vtu.yields">
							<span id="vtuTitle{{helper.parseCamelCaseForIds(yield.title, true)}}"
								class="title">{{yield.title}}</span>
							<br>
							<span id="vtuDescription{{helper.parseCamelCaseForIds(yield.title, true)}}"
								class="description">{{yield.description}}</span>
						</div>
					</div>
					<span id="vtuOutcome" class="introduction" [innerHTML]="vtu.outcome"></span>
				</div>
			</div>
		</vcl-modal>

		<div class="contentImg" *ngIf="(productSelected.name === 'MultiProduct' || 
		productSelected.name === 'CreditTarget') && channel === '163';else prueba">
			<picture>
				<source srcset="{{imageLink4}}" media="(min-width: 1281px)">
				<source srcset="{{imageLink3}}" media="(min-width: 768px)">
				<source srcset="{{imageLink2}}" media="(min-width: 688px)">
				<img src="{{imageLink1}}" alt="imagen principal"> <!-- imagen principal -->
			</picture>
		</div>
		<ng-template class="contentImg" #prueba>
			<img src="assets/images/{{productSelected.image}}" alt="error_img" id="imgSuccess">
			<span class="title">{{productSelected.es}}</span>
		</ng-template>
		<div class="tabs" *ngIf="productSelected.name !== 'MultiProduct'">
			<vcl-tabs [current]="currentTab" [tabs]="listTabs" (tabChange)="onClickTab($event)"></vcl-tabs>
		</div>

		<section id="benefits" *ngIf="currentTab == 1" class="section-tab-margin">
			<span *ngIf="channel === '163'">
				<img class="benefit_logo" src="{{productSelected.benefits_logo}}" alt="error_img" id="imgSuccess">
			</span>
			<br>
			<span
				*ngIf="productSelected.code !== '200' && productSelected.code !== '232' && productSelected.code !== '205'"
				id="benefitsDescription" class="benefitsDescription">{{productsDetail.benefits.title}}</span>
			<span *ngIf="productSelected.code === '200' || productSelected.code === '205' " id="benefitsDescription"
				class="benefitsDescription benefitsTitle">{{productsDetail.benefits.title}}</span>
			<div *ngIf="productSelected.code === '232'">
				<h3 class="title">{{productsDetail.benefits.title}}</h3>
			</div>
			<span *ngIf="productsDetail.benefits.subtitle"
				[innerHTML]="sanitize(productsDetail.benefits.subtitle)"></span>
			<div class="space"></div>
			<ul *ngIf="productSelected.code !== '200' && productSelected.code !== '205'">
				<vcl-list>
					<li *ngFor="let benefit of productsDetail.benefits.list" vclListSimple>
						<span id="iconCheck" class="icon icon-itaufonts_check">
						</span>
						<vcl-list-text>
							{{benefit}}
						</vcl-list-text>
					</li>
				</vcl-list>
			</ul>
			<ul *ngIf="productSelected.code === '200' || productSelected.code === '205'" class="benefitTraditional">
				<vcl-list>
					<li *ngFor="let benefit of productsDetail.benefits.list"
						[innerHTML]="sanitize(benefit.icon + benefit.title + benefit.description)" vclListSimple>
					</li>
				</vcl-list>
			</ul>
			<!-- <div class="benefits-terms-and-conditions" *ngIf="productSelected.name !== 'MultiProduct'">
				<span *ngIf="productSelected.code !== '205' && productSelected.code !== '200'" id="benefitsTerms" class="benefits-terms-and-conditions-font">{{copyService.copies.product_detail_terms_conditions}}</span>
				<span *ngIf="productSelected.code == '205'" id="benefitsTerms" class="benefits-terms-and-conditions-font">{{copyService.copies.product_detail_terms_conditions_tc}}</span>
			</div> -->
		</section>

		<section id="characteristics" *ngIf="currentTab == 2" class="section_characteristic section-tab-margin">
			<div id="characteristicsDescription" class="characteristic">
				<span *ngIf="productsDetail.characteristics.title"
					[innerHTML]="sanitize(productsDetail.characteristics.title)"></span>
				<div *ngIf="productsDetail.characteristics.title" class="space"></div>
				<span id="characteristicsSubtitle" class="characteristicsSubtitle"
					*ngIf="productsDetail.characteristics.subtitle">{{productsDetail.characteristics.subtitle}}</span>
				<ul>
					<vcl-list>
						<li *ngFor="let characteristic of productsDetail.characteristics.principal" vclListSimple>
							<span id="iconCheck" class="icon icon-itaufonts_check">
							</span>
							<vcl-list-text>
								{{characteristic}}
							</vcl-list-text>
						</li>
					</vcl-list>
				</ul>
			</div>

			<div id="characteristicsTransactional" class="box_transactionalBenefits row">
				<div *ngFor="let benefit of productsDetail.characteristics.transactionalBenefits"
					class="transactionalBenefits col-sm-12 col-md-4 mt-8">
					<div class="box_incomes">
						<div class="box_icon">
							<em id="benefitIcon" [class]="benefit.icon"></em>
						</div>
						<div class="span_description xbold">
							<span id="textIncomes">
								{{benefit.text_incomes}}
							</span>
						</div>
					</div>

					<div class="box_transactionalDetail">
						<ul>
							<vcl-list>
								<li *ngFor="let detail of benefit.details; let i = index" vclListSimple>
									<span id="iconCheck" class="icon icon-itaufonts_check">
									</span>
									<vcl-list-text>
										<span [innerHTML]="sanitize(detail)"></span>
									</vcl-list-text>
								</li>
							</vcl-list>
						</ul>
					</div>
				</div>
			</div>

			<div id="characteristicsVTU" class="characteristic_vtu">
				<div class="text">
					<span id="vtuLink" class="vut_link">{{productsDetail.characteristics.vtu_text.initial}}
						<vcl-link [linkId]="characteristicsLink" (click)="showModalVTU()"
							[label]="productsDetail.characteristics.vtu_text.link">
						</vcl-link>
						{{productsDetail.characteristics.vtu_text.finally}}
					</span>
				</div>
				<br>
				<span id="vtuNote" class="benefitsDescription vtu_note">{{productsDetail.characteristics.note}}</span>
			</div>
		</section>
		<section id="costs" *ngIf="currentTab == 3 && productSelected.code !== '200'" class="section-tab-margin">
			<div *ngIf="productsDetail.costs">
				<div class="text">
					<span id="costsTitle" class="benefitsDescription"
						[innerHTML]="sanitize(productsDetail.costs.description)"></span>
					<vcl-link [linkId]="characteristicsLink" (click)="openLink(productsDetail.costs.descriptionLink)"
						[label]="productsDetail.costs.descriptionLink">
					</vcl-link>
				</div>

				<div id="costsTable" *ngIf="productsDetail.costs.table" class="cost-table">
					<vcl-table>
						<table cdk-table [dataSource]="productsDetail.costs.table.datasource">
							<ng-container *ngFor="let title of productsDetail.costs.table.title"
								[cdkColumnDef]="title.key">
								<th cdk-header-cell *cdkHeaderCellDef>{{ title.value }}</th>
								<td cdk-cell *cdkCellDef="let element">{{ element[title.key] }}</td>
							</ng-container>
							<tr cdk-header-row *cdkHeaderRowDef="tableHeaderFields;"></tr>
							<tr cdk-row *cdkRowDef="let row; columns: tableHeaderFields;"></tr>
						</table>
					</vcl-table>
				</div>
				<div id="costDescriptionMedium" *ngIf="productsDetail.costs.description_medium">
					<div class="text">
						<span class="benefitsDescription"
							[innerHTML]="sanitize(productsDetail.costs.description_medium.title)"></span>
					</div>
					<ul class="benefitTraditional">
						<vcl-list>
							<li *ngFor="let costs of productsDetail.costs.description_medium.body.list"
								[innerHTML]="costs" vclListSimple>
							</li>
						</vcl-list>
					</ul>
					<div class="text">
						<span id="transactionText{{i}}" class="benefitsDescription"
							[innerHTML]="sanitize(productsDetail.costs.description_medium.description)"></span>
						<vcl-link [linkId]="characteristicsLink"
							(click)="openLink(productsDetail.costs.description_medium.link)"
							[label]="productsDetail.costs.description_medium.link">
						</vcl-link>
					</div>
				</div>
				<div id="costTrasaction{{i}}" *ngIf="productsDetail.costs.transactionDescription; let i = index"
					class="transaction-text">
					<div class="text">
						<span id="transactionText{{i}}" class="benefitsDescription"
							[innerHTML]="sanitize(productsDetail.costs.transactionDescription)"></span>
					</div>
					<div id="transactionList{{i}}" class="characteristic cost-items">
						<ul>
							<vcl-list>
								<li *ngFor="let benefit of productsDetail.costs.items" vclListSimple>
									<span class="icon icon-itaufonts_check">
									</span>
									<vcl-list-text>
										{{benefit}}
									</vcl-list-text>
								</li>
							</vcl-list>
						</ul>
					</div>
				</div>
				<ul id="costsList" *ngIf="productsDetail.costs.list">
					<vcl-list>
						<li *ngFor="let costs of productsDetail.costs.list" vclListSimple>
							<span class="icon icon-itaufonts_check">
							</span>
							<vcl-list-text>
								{{costs}}
							</vcl-list-text>
						</li>
					</vcl-list>
				</ul>
				<div id="costFooterText" class="cost-footer">
					<span [id]="costsFooter" class="cost-footer-text"
						[innerHTML]="sanitize(productsDetail.costs.footer)"></span>
				</div>
				<div *ngIf="productsDetail.costs.note" class="creditCardNote">
					<div *ngIf="productSelected.code !== '205'">
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note_more.description_one }} <vcl-link [linkId]="characteristicsLink"
								(click)="openLink(productsDetail.costs.note_more.link)"
								[label]="productsDetail.costs.note_more.label_link">
							</vcl-link></span>
						<br>
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note_more.description_two }}</span>
					</div>
					<div *ngIf="productSelected.code === '205'">
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note_more.description_one }} <vcl-link [linkId]="characteristicsLink"
								(click)="openLink(productsDetail.costs.note_more.link)"
								[label]="productsDetail.costs.note_more.label_link">
							</vcl-link></span>
						<br>
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note_more.description_two }}</span>
					</div>
				</div>
				<div *ngIf="productsDetail.costs.note" class="creditCardNote">
					<div *ngIf="productSelected.code !== '205'">
						<h3 id="costsTitle" class="noteTitle" [innerHTML]="sanitize(productsDetail.costs.note.title)">
						</h3>
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note.description }}</span>
						<vcl-link [linkId]="characteristicsLink" (click)="openLink(productsDetail.costs.note.link)"
							[label]="productsDetail.costs.note.label">
						</vcl-link>
					</div>
					<div *ngIf="productSelected.code === '205'">
						<h3 id="costsTitle" class="noteTitle" [innerHTML]="sanitize(productsDetail.costs.note.title)">
						</h3>
						<span id="costsNote" class="benefitsDescription vtu_note">{{
							productsDetail.costs.note.description }}</span>
						<br />
						<vcl-link [linkId]="characteristicsLink" (click)="openLink(productsDetail.costs.note.link)"
							[label]="productsDetail.costs.note.label">
						</vcl-link>
					</div>
				</div>

			</div>
		</section>
		<section id="costs" *ngIf="currentTab == 3 && productSelected.code === '200'" class="section-tab-margin">
			<span *ngIf="productSelected.code === '200'" id="benefitsDescription"
				class="benefitsDescription benefitsTitle">{{productsDetail.costs.title}}</span>
			<span *ngIf="productsDetail.costs.subtitle" [innerHTML]="sanitize(productsDetail.costs.subtitle)"></span>
			<div class="space"></div>
			<ul *ngIf="productSelected.code === '200'" class="benefitTraditional">
				<vcl-list>
					<li *ngFor="let costs of productsDetail.costs.list"
						[innerHTML]="sanitize(costs.icon + costs.title + costs.description1 + costs.rate + costs.description2)"
						vclListSimple>
					</li>
				</vcl-list>
			</ul>
		</section>
		<section id="requirements" *ngIf="currentTab == 4 && channel === '163'" class="section-tab-margin">
			<ul id="requirementsList">
				<vcl-list>
					<li *ngFor="let requirement of productsDetail.requirements.principal" vclListSimple>
						<span class="icon icon-itaufonts_check">
						</span>
						<vcl-list-text>
							{{requirement}}
						</vcl-list-text>
					</li>
				</vcl-list>
			</ul>
			<div *ngIf="productSelected.code === '205'" class="benefits-terms-and-conditions">
				<span id="benefitsTerms"
					class="cost-footer-text">{{productsDetail.requirements.note_requirements}}</span>
			</div>
		</section>
		<section id="requirements" *ngIf="currentTab == 4 && channel !== '163'" class="section-tab-margin">
			<ul id="requirementsList">
				<vcl-list>
					<li *ngFor="let requirement of productsDetail.requirements" vclListSimple>
						<span class="icon icon-itaufonts_check">
						</span>
						<vcl-list-text>
							{{requirement}}
						</vcl-list-text>
					</li>
				</vcl-list>
			</ul>
			<div *ngIf="productSelected.code === '205'" class="benefits-terms-and-conditions">
				<span id="benefitsTerms"
					class="benefits-terms-and-conditions-font">{{copyService.copies.product_requirements_tc}}</span>
			</div>
		</section>
	</div>

	<div *ngIf="channel !== '163';else allies">
		<app-controls id="selectProductDetailBtns" [hasPrevious]="true"
			*ngIf="productSelected.name === 'Payroll' || productSelected.name === 'Saving Account' || productSelected.name === 'ConsultationRequest'; else creditCard"
			[nextLabel]="productSelected.name === consultation_request ? copyService.copies.product_selection_consultation_request : copyService.copies.product_selection_go_ahead"
			(next)="checkBioCatch()" (only_previous)="previous()"></app-controls>
		<ng-template #creditCard><app-controls id="selectProductDetailBtns"
				[nextLabel]="productSelected.product_type === 'multi' ? 'Ver productos':false" [hasPrevious]="true"
				(only_previous)="previous()" (next)="checkBioCatch()"></app-controls></ng-template>
	</div>
	<ng-template #allies class="next_button">
		<app-controls id="selectProductDetailAlly" [hasPrevious]="false"
			[nextLabel]=" copyService.copies.product_selection_allies " (next)="checkBioCatch()"
			(only_previous)="previous()"></app-controls>
	</ng-template>


</div>